var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8864_2046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5 0C42.9187 0 32.575 3.13772 23.777 9.01638C14.979 14.895 8.12176 23.2506 4.07247 33.0264C0.0231808 42.8023 -1.0363 53.5593 1.02801 63.9373C3.09232 74.3153 8.1877 83.8481 15.6698 91.3302C23.1519 98.8123 32.6847 103.908 43.0627 105.972C53.4407 108.036 64.1977 106.977 73.9736 102.928C83.7494 98.8783 92.105 92.021 97.9836 83.223C103.862 74.425 107 64.0813 107 53.5C106.985 39.3156 101.343 25.7166 91.3133 15.6867C81.2834 5.65686 67.6844 0.0153415 53.5 0ZM53.5 98.0833C44.6823 98.0833 36.0625 95.4686 28.7308 90.5697C21.3992 85.6708 15.6848 78.7078 12.3104 70.5613C8.93599 62.4148 8.05309 53.4505 9.77335 44.8022C11.4936 36.1539 15.7398 28.2099 21.9748 21.9748C28.2099 15.7397 36.1539 11.4936 44.8022 9.77332C53.4506 8.05307 62.4148 8.93596 70.5613 12.3104C78.7079 15.6848 85.6708 21.3991 90.5697 28.7308C95.4686 36.0625 98.0834 44.6823 98.0834 53.5C98.0704 65.3203 93.369 76.6527 85.0109 85.0108C76.6527 93.369 65.3203 98.0704 53.5 98.0833Z",
    fill: "#FF3064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5013 22.2891C52.3189 22.2891 51.1849 22.7588 50.3488 23.5949C49.5127 24.431 49.043 25.565 49.043 26.7474V62.4141C49.043 63.5965 49.5127 64.7305 50.3488 65.5666C51.1849 66.4027 52.3189 66.8724 53.5013 66.8724C54.6837 66.8724 55.8177 66.4027 56.6538 65.5666C57.4899 64.7305 57.9596 63.5965 57.9596 62.4141V26.7474C57.9596 25.565 57.4899 24.431 56.6538 23.5949C55.8177 22.7588 54.6837 22.2891 53.5013 22.2891Z",
    fill: "#FF3064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9596 80.2474C57.9596 77.7851 55.9636 75.7891 53.5013 75.7891C51.039 75.7891 49.043 77.7851 49.043 80.2474C49.043 82.7097 51.039 84.7057 53.5013 84.7057C55.9636 84.7057 57.9596 82.7097 57.9596 80.2474Z",
    fill: "#FF3064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8864_2046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.3689823d556d963d94c1fbcfae328c05.svg";
export { ForwardRef as ReactComponent };